import { useId, type ReactNode } from 'react';
import styles from './Switch.module.css';

export interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: ReactNode;
  hint?: ReactNode;
  disabled?: boolean;
}

/** A labelled on/off switch. The whole row is the hit target (≥ 44 px tall). */
export function Switch({ checked, onChange, label, hint, disabled = false }: SwitchProps) {
  const id = useId();
  return (
    <div className={styles['row']}>
      <div className={styles['text']}>
        <span id={`${id}-label`} className={styles['label']}>
          {label}
        </span>
        {hint ? (
          <span id={`${id}-hint`} className={styles['hint']}>
            {hint}
          </span>
        ) : null}
      </div>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-labelledby={`${id}-label`}
        aria-describedby={hint ? `${id}-hint` : undefined}
        disabled={disabled}
        className={styles['switch']}
        onClick={() => {
          onChange(!checked);
        }}
      >
        <span className={styles['track']} aria-hidden="true">
          <span className={styles['thumb']} />
        </span>
      </button>
    </div>
  );
}
